import { useState } from 'react'
import useSWR from 'swr'
import { api } from '@/api'
import { formatPrice } from '@/utils'

export default function AdminServices() {
  const [isEditing, setIsEditing] = useState(false)
  const [editingService, setEditingService] = useState<any>(null)

  const { data, mutate } = useSWR('/services', () => api.services.getAll())
  const services = data?.data || []

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    
    const serviceData = {
      name: formData.get('name') as string,
      description: formData.get('description') as string,
      duration: parseInt(formData.get('duration') as string),
      price: parseInt(formData.get('price') as string),
      category: formData.get('category') as string,
    }

    if (editingService) {
      await api.services.update(editingService.id, serviceData)
    } else {
      await api.services.create(serviceData)
    }

    setIsEditing(false)
    setEditingService(null)
    mutate()
  }

  const handleDelete = async (id: number) => {
    await api.services.delete(id)
    mutate()
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold text-gray-900">服务项目</h2>
        <button
          onClick={() => {
            setEditingService(null)
            setIsEditing(true)
          }}
          className="btn-primary py-2 px-4 text-sm"
        >
          添加服务
        </button>
      </div>

      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <form onSubmit={handleSubmit} className="card w-full max-w-md max-h-[90vh] overflow-y-auto">
            <h3 className="font-semibold text-lg mb-4">
              {editingService ? '编辑服务' : '添加服务'}
            </h3>

            <div className="space-y-3">
              <input
                name="name"
                defaultValue={editingService?.name}
                placeholder="服务名称"
                className="input"
                required
              />
              <textarea
                name="description"
                defaultValue={editingService?.description}
                placeholder="服务描述"
                className="input resize-none"
                rows={3}
              />
              <div className="grid grid-cols-2 gap-3">
                <input
                  name="duration"
                  type="number"
                  defaultValue={editingService?.duration || 60}
                  placeholder="时长 (分钟)"
                  className="input"
                  required
                />
                <input
                  name="price"
                  type="number"
                  defaultValue={editingService?.price || 0}
                  placeholder="价格"
                  className="input"
                  required
                />
              </div>
              <input
                name="category"
                defaultValue={editingService?.category}
                placeholder="分类"
                className="input"
              />
            </div>

            <div className="flex gap-2 mt-4">
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="btn-secondary flex-1"
              >
                取消
              </button>
              <button type="submit" className="btn-primary flex-1">
                保存
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="space-y-3">
        {services.map(service => (
          <div key={service.id} className="card">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <h3 className="font-semibold text-gray-900">{service.name}</h3>
                <p className="text-sm text-gray-600 mt-1">{service.description}</p>
                <div className="flex gap-3 mt-2 text-sm text-gray-500">
                  <span>{service.duration}分钟</span>
                  <span>{service.category}</span>
                </div>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-primary-600">{formatPrice(service.price)}</p>
                <div className="flex gap-2 mt-2">
                  <button
                    onClick={() => {
                      setEditingService(service)
                      setIsEditing(true)
                    }}
                    className="text-sm text-primary-600"
                  >
                    编辑
                  </button>
                  <button
                    onClick={() => handleDelete(service.id)}
                    className="text-sm text-red-600"
                  >
                    删除
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
